var _module_exports = "\n<div class=\"tb-nav-tree-container\"></div>\n";;
var path = '/components/nav-tree.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;